
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const stayOnTrack = useStore((state) => state.stayOnTrack);
  const setStayOnTrack = useStore((state) => state.setStayOnTrack);
  const [next, setNext] = useState(stayOnTrack.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setStayOnTrack(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.stayOnTrack.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={stayOnTrack} onChange={handleChange}>
          <MultiOption value={'I’ll log all my meals before eating'}>
            <span>🥗</span> {t('onboarding.stayOnTrack.options.log')}
          </MultiOption>
          <MultiOption value={'I’ll find someone to stay accountable with'}>
            <span>👯</span> {t('onboarding.stayOnTrack.options.find')}
          </MultiOption>
          <MultiOption value={'I’ll use recipes and plan ahead'}>
            <span>📅</span> {t('onboarding.stayOnTrack.options.useRecipes')}
          </MultiOption>
          <MultiOption value={"I’ll use an activity tracker"}>
            <span>🏃‍♀️</span> {t('onboarding.stayOnTrack.options.useTracker')}
          </MultiOption>
          <MultiOption value={'I’ll monitor my calorie intake'}>
            <span>🔢</span> {t('onboarding.stayOnTrack.options.monitor')}
          </MultiOption>
           <MultiOption value={'Not sure yet'}>
            <span>🤷</span> {t('onboarding.stayOnTrack.options.notSure')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.stayOnTrack.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'stay-on-track',
              answer: stayOnTrack.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
